import http from "../http-common";

let pendingRequest = null;

const state = {
    items: [],
    loaded: false,
    loading: false,
};

const getters = {
    productTypes: state => state.items,
};

const actions = {
    fetchOnce({ commit, state }) {
        if (state.loaded) {
            return Promise.resolve(state.items);
        }

        if (state.loading && pendingRequest) {
            return pendingRequest;
        }

        commit("setLoading", true);

        pendingRequest = http
            .get("/listProductTypes")
            .then(response => {
                commit("setItems", response.data);
                pendingRequest = null;
                return response.data;
            })
            .catch(error => {
                commit("setLoading", false);
                pendingRequest = null;
                throw error;
            });

        return pendingRequest;
    },
};

const mutations = {
    setItems(state, items) {
        state.items = items;
        state.loaded = true;
        state.loading = false;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    reset(state) {
        state.items = [];
        state.loaded = false;
        state.loading = false;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
